import React, { useRef } from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Autocomplete,
  FormGroup,
  Paper,
  Alert,
} from "@mui/material";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import Notify from "../../../Notify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SaveIcon from "@mui/icons-material/Save";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import InputMask from "react-input-mask";
import { getData, putData, getCodeArg } from "../../../../services/library";
import moment from "moment";
import BuscadorClienteFactura from "../BusquedaCliente/BuscadorClienteFactura";
import { UrlApi } from "../../../../services/apirest";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";
import { describirCambiosCliente } from "../../logs/cambiosCliente";

function EdicionEnvasado(props) {
  const [dataCliente, setDataCliente] = useState({
    ...props.cliente,
    telefono_1: props.cliente.telefono_1
      ? props.cliente.telefono_1.replace(/(\+?549)+/g, "").trim()
      : "",
    telefono_2: props.cliente.telefono_2
      ? props.cliente.telefono_2.replace(/(\+?549)+/g, "").trim()
      : "",
    telefono_3: props.cliente.telefono_3
      ? props.cliente.telefono_3.replace(/(\+?549)+/g, "").trim()
      : "",
    facturar_a: props.cliente.facturar_a || null,
  });
  // Snapshot del cliente tal como se cargó en el formulario (teléfonos sin +549), para el log de cambios
  const clienteOriginal = useRef(dataCliente);
  const [sucursales, setSucursales] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [comerciales, setComerciales] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [tipo, setTipo] = useState(props.cliente.tipo_doc_afip);
  const [condiciones, setCondiciones] = useState(null);
  // const [categorias, setCategorias] = useState(null);
  const [convenios, setConvenios] = useState(null)
  const [sitIva, setSitIva] = useState(null);
  const [tipoCliente, setTipoCliente] = useState(null);
  const [usos, setUsos] = useState(null);
  const [disBtn, setDisBtn] = useState(false);
  const [sitIvaSeleccionada, setSitIvaSeleccionada] = useState("");
  const [condPagoSeleccionada, setCondPagoSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [comercialSeleccionado, setComercialSeleccionado] = useState("");
  // const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const [convenioSeleccionado, setConvenioSeleccionado] = useState("")
  const [tipoClienteSeleccionado, setTipoClienteSeleccionado] = useState("");
  const [usoSeleccionado, setUsoSeleccionado] = useState("");
  const [buscando, setBuscando] = useState(false);
  const [checked, setChecked] = useState(
    props.cliente.factura_consfinal === 1 ? true : false,
  );
  const [clienteFactura, setClienteFactura] = useState(null);
  const [checkedPrecioEspecial, setCheckedPrecioEspecial] = useState(
    props.cliente.precio_especial === 1 ? true : false,
  );
  const [checkedEntregaConRemito, setCheckedEntregaConRemito] = useState(
    props.cliente.entrega_con_remito === 1 ? true : false,
  );

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [codArg, setCodArg] = useState("");
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };

  const handleCheckedPrecioEspecial = (event) => {
    setCheckedPrecioEspecial(event.target.checked);
  };

  // const almacenar = (e) => {
  //   setDataCliente({
  //     ...dataCliente,
  //     [e.target.name]: e.target.value === "" ? null : e.target.value,
  //   });
  // };
  const almacenar = (e) => {
  let valor = e.target.value === "" ? null : e.target.value;
  
  // Si es el campo iibb_nro_inscripcion y el convenio seleccionado es 1, formatear
  if (e.target.name === "iibb_nro_inscripcion" && convenioSeleccionado?.id_convenio === 1 && valor) {
    // Guardamos el valor formateado directamente
    valor = formatearIIBB(valor);
  }
  
  setDataCliente({
    ...dataCliente,
    [e.target.name]: valor,
  });
};

  // Función para formatear el número de IIBB
const formatearIIBB = (valor) => {
  if (!valor) return '';
  
  // Eliminar todo lo que no sea número
  let numeros = valor.replace(/\D/g, '');
  
  // Limitar a 10 números máximo (3+6+1)
  if (numeros.length > 10) {
    numeros = numeros.slice(0, 10);
  }
  
  // Aplicar formato progresivo mientras escribe
  if (numeros.length <= 3) {
    return numeros;
  } else if (numeros.length <= 9) {
    return `${numeros.slice(0, 3)}-${numeros.slice(3)}`;
  } else {
    return `${numeros.slice(0, 3)}-${numeros.slice(3, 9)}-${numeros.slice(9, 10)}`;
  }
};

// Guardar el id_convenio anterior
const prevConvenioIdRef = useRef(convenioSeleccionado?.id_convenio);

useEffect(() => {
  const prevId = prevConvenioIdRef.current;
  const currentId = convenioSeleccionado?.id_convenio;
  
  // Solo limpiar si realmente cambió el convenio (no cuando se carga por primera vez)
  if (prevId !== undefined && prevId !== currentId && currentId !== undefined) {
    setDataCliente((prev) => ({
      ...prev,
      iibb_nro_inscripcion: null,
    }));
  }
  
  prevConvenioIdRef.current = currentId;
}, [convenioSeleccionado?.id_convenio]);
  //******************************************************************************************************** */
  //Fetchs para traer datos de la api a los desplegables
  useEffect(() => {
    getData("/sucursales", setSucursales);
  }, [dataCliente.id_tipocliente]);

  useEffect(() => {
    // getData("/categorias", setCategorias);
    getData("/convenios", setConvenios);
    getData("/representantes/activos", setComerciales);
    getData("/provincias", setProvincias);
    getData("/condicion_pago", setCondiciones);
    getData("/condiciones_iva/envasado", setSitIva);
    getData("/tipoclienteenvasado", setTipoCliente);
    getData("/envasado_usos", setUsos);
    getCodeArg(setCodArg);
  }, []);

  // Verificacion de si el cliente esta en alguna hoja de ruta (para advertir al cambiar sucursal)
  const [hojas, setHojas] = useState(null);

  useEffect(() => {
    if (dataCliente.id) {
      getData("/envasado_clientes_ruta/verificacion/" + dataCliente.id, setHojas);
    }
  }, [dataCliente.id]);

  const cambioSucursalConHojas =
    sucursalSeleccionada?.id !== undefined &&
    sucursalSeleccionada.id !== dataCliente.id_sucursal &&
    hojas &&
    hojas.length > 0;

  useEffect(() => {
    getData("/localidades/prov/" + provinciaSeleccionada?.id, setLocalidades);
    setBuscando(false);
  }, [dataCliente.id_provincia, provinciaSeleccionada]);

  useEffect(() => {
    getData("/localidades/prov/" + provinciaSeleccionada?.id, setLocalidades);

    if (!(props.cliente.id_provincia === provinciaSeleccionada.id)) {
      setLocalidadSeleccionada("");
    }
    setBuscando(false);
  }, [dataCliente.id_provincia, provinciaSeleccionada]);

  const handleClose = () => {
    props.setOpen(false);
  };

  async function guardarCliente(e) {
    setDisBtn(true);
    let facturaAnombreDe =
      dataCliente.facturar_a === "SELF"
        ? props.cliente.id
        : dataCliente.facturar_a;
    const datosGuardar = {
        usuario: localStorage.getItem("user"),
        sisven_id: dataCliente.sisven_id === "" ? null : dataCliente.sisven_id,
        razon_social: dataCliente.razon_social,
        direccion_fiscal: dataCliente.direccion_fiscal,
        telefono_1: dataCliente.telefono_1,
        telefono_2: dataCliente.telefono_2,
        telefono_3: dataCliente.telefono_3,
        mails: dataCliente.mails,
        cuit: dataCliente.cuit,
        id_sucursal: sucursalSeleccionada.id,
        // id_categoria: categoriaSeleccionada.id,
        id_localidad: localidadSeleccionada.id,
        id_comercial: comercialSeleccionado.id,
        // id_provincia: provinciaSeleccionada.id,
        situacion_iva: sitIvaSeleccionada.id,
        id_condicionpago: condPagoSeleccionada.id,
        // limite_credito:
        //   dataCliente.limite_credito === "" ? null : dataCliente.limite_credito,
        id_tipocliente: tipoClienteSeleccionado.id,
        observaciones: dataCliente.observaciones,
        // envase_10_kg: dataCliente.envase_10_kg,
        // envase_15_kg: dataCliente.envase_15_kg,
        // envase_45_kg: dataCliente.envase_45_kg,
        uso: usoSeleccionado.id,
        tipo_doc_afip: dataCliente.tipo_doc_afip,
        factura_consfinal: dataCliente.factura_consfinal,
        porc_perc_iva: dataCliente.porc_perc_iva,
        porc_exc_perc_iva: dataCliente.porc_exc_perc_iva,
        vto_exc_perc_iva: dataCliente.vto_exc_perc_iva,
        precio_especial: dataCliente.precio_especial,
        entrega_con_remito: dataCliente.entrega_con_remito,
        facturar_a: facturaAnombreDe,
        id_convenio: convenioSeleccionado.id_convenio,
        iibb_nro_inscripcion:dataCliente.iibb_nro_inscripcion
      };

    await putData(
      e,
      "/envasado_clientes/" + dataCliente.id,
      datosGuardar,
      setNotificacion,
    );

    // Log de cambios: se comparan valores legibles (nombres en vez de IDs, Sí/No en vez de 0/1)
    const cambios = describirCambiosCliente(
      clienteOriginal.current,
      datosGuardar,
      { sucursales, localidades, comerciales, sitIva, condiciones, tipoCliente, usos, convenios },
      {
        sucursal: sucursalSeleccionada,
        localidad: localidadSeleccionada,
        comercial: comercialSeleccionado,
        sitIva: sitIvaSeleccionada,
        condPago: condPagoSeleccionada,
        tipoCliente: tipoClienteSeleccionado,
        uso: usoSeleccionado,
        convenio: convenioSeleccionado,
      }
    );

    if (cambios) {
      registrarAccion(
        DONDE.CLIENTES,
        `Editó cliente ${dataCliente.id} - ${datosGuardar.razon_social}: ${cambios}`
      );
    }
  }

  useEffect(() => {
    // sitIva
    if (dataCliente.situacion_iva !== "" && sitIva) {
      const sitEncontrada = sitIva.find(
        (d) => d.id === parseInt(dataCliente.situacion_iva),
      );
      if (sitEncontrada) {
        setSitIvaSeleccionada(sitEncontrada);
      }
    }
  }, [sitIva]);

  useEffect(() => {
    // cond Pago
    if (dataCliente.id_condicionpago !== "" && condiciones) {
      const condicionEncontrada = condiciones.find(
        (d) => d.id === dataCliente.id_condicionpago,
      );
      if (condicionEncontrada) {
        setCondPagoSeleccionada(condicionEncontrada);
      }
    }
  }, [condiciones]);

  useEffect(() => {
    // sucursal
    if (dataCliente.id_sucursal !== "" && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === dataCliente.id_sucursal,
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
  }, [sucursales]);

  useEffect(() => {
    // provincia
    if (dataCliente.id_provincia !== "" && provincias) {
      const provinciaEncontrada = provincias.find(
        (d) => d.id === dataCliente.id_provincia,
      );
      if (provinciaEncontrada) {
        setProvinciaSeleccionada(provinciaEncontrada);
      }
    }
  }, [provincias]);

  useEffect(() => {
    // localidad
    if (dataCliente.id_localidad && localidades?.length) {
      const localidadEncontrada = localidades.find(
        (d) => d.id === Number(dataCliente.id_localidad),
      );

      if (localidadEncontrada) {
        setLocalidadSeleccionada(localidadEncontrada);
      }
    }
  }, [localidades]);

  useEffect(() => {
    // comerciales
    if (dataCliente.id_comercial !== "" && comerciales) {
      const comercialEncontrado = comerciales.find(
        (d) => d.id === dataCliente.id_comercial,
      );
      if (comercialEncontrado) {
        setComercialSeleccionado(comercialEncontrado);
      }
    }
  }, [comerciales]);

  // useEffect(() => {
  //   // categorias
  //   if (dataCliente.id_categoria !== "" && categorias) {
  //     const categoriaEncontrada = categorias.find(
  //       (d) => d.id === dataCliente.id_categoria,
  //     );
  //     if (categoriaEncontrada) {
  //       setCategoriaSeleccionada(categoriaEncontrada);
  //     }
  //   }
  // }, [categorias]);

    useEffect(() => {
    // convenios
    if (dataCliente.id_convenio !== "" && convenios) {
      const convenioEncontrado = convenios.find(
        (d) => d.id_convenio === dataCliente.id_convenio,
      );
      if (convenioEncontrado) {
        setConvenioSeleccionado(convenioEncontrado);
      }
    }
  }, [convenios]);

  useEffect(() => {
    // tipo cliente
    if (dataCliente.id_tipocliente !== "" && tipoCliente) {
      const tipoEncontrado = tipoCliente.find(
        (d) => d.id === dataCliente.id_tipocliente,
      );
      if (tipoEncontrado) {
        setTipoClienteSeleccionado(tipoEncontrado);
      }
    }
  }, [tipoCliente]);

  useEffect(() => {
    // uso
    if (dataCliente.uso !== "" && usos) {
      const usoEncontrado = usos.find((d) => d.id === dataCliente.uso);
      if (usoEncontrado) {
        setUsoSeleccionado(usoEncontrado);
      }
    }
  }, [usos]);

  useEffect(() => {
    let respInscrip = sitIvaSeleccionada?.id === 1 ? 1.75 : null;
    let tieneExencion =
      sitIvaSeleccionada?.id === 1 ? dataCliente.porc_exc_perc_iva : null;
    let vencimientoExencion =
      sitIvaSeleccionada?.id === 1 ? dataCliente.vto_exc_perc_iva : null;

    if (sitIvaSeleccionada?.id === 4) {
      setDataCliente((prev) => ({
        ...prev,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    } else if (
      Object.keys(sitIvaSeleccionada).length !== 0 &&
      sitIvaSeleccionada?.id !== 4
    ) {
      setDataCliente((prev) => ({
        ...prev,
        tipo_doc_afip: 80,
        porc_perc_iva: respInscrip,
        porc_exc_perc_iva: tieneExencion,
        vto_exc_perc_iva: vencimientoExencion,
      }));
    }
  }, [sitIvaSeleccionada]);

  useEffect(() => {
    if (props.cliente.tipo_doc_afip === dataCliente.tipo_doc_afip) {
      setDataCliente((prev) => ({
        ...prev,
        cuit: props.cliente.cuit,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        cuit: "",
      }));
    }
  }, [dataCliente.tipo_doc_afip]);

  useEffect(() => {
    if (checked === true) {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 0,
      }));
    }
  }, [checked]);

  useEffect(() => {
    if (checkedPrecioEspecial === true) {
      setDataCliente((prev) => ({
        ...prev,
        precio_especial: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        precio_especial: 0,
      }));
    }
  }, [checkedPrecioEspecial]);

  useEffect(() => {
    if (checkedEntregaConRemito === true) {
      setDataCliente((prev) => ({
        ...prev,
        entrega_con_remito: 1,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        entrega_con_remito: 0,
      }));
    }
  }, [checkedEntregaConRemito]);

  const handleClienteFacturaChange = (cliente) => {
    setClienteFactura(cliente);

    // Actualizar solo el ID en dataCliente
    if (cliente) {
      setDataCliente((prev) => ({
        ...prev,
        facturar_a: cliente.id,
      }));
    } else {
      setDataCliente((prev) => ({
        ...prev,
        facturar_a: null,
      }));
    }
  };

  useEffect(() => {
    const buscarClienteFacturacion = async () => {
      // Si el cliente tiene facturar_a configurado
      if (props.cliente.facturar_a) {
        // Si es 'SELF', crear objeto especial
        if (props.cliente.facturar_a === props.cliente.id) {
          setClienteFactura({
            id: props.cliente.id,
            nombre_cliente_remito: "Facturación Propia",
            razon_social: "Facturación Propia",
          });
        } else {
          try {
            // Para otros casos, buscar el cliente por ID usando fetch
            const response = await fetch(
              `${UrlApi}/envasado_clientes/xid/${props.cliente.facturar_a}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  // 'Authorization': `Bearer ${localStorage.getItem('token')}` // si usas autenticación
                },
              },
            );

            if (response.ok) {
              const clienteEncontrado = await response.json();
              // console.log("response", clienteEncontrado[0]);

              if (clienteEncontrado) {
                setClienteFactura({
                  id: clienteEncontrado[0].id,
                  // Si BuscadorClienteFactura usa razon_social, pon el nombre_cliente_remito allí
                  razon_social: clienteEncontrado[0]?.razon_social,
                  // nombre_cliente_remito: clienteEncontrado.nombre_cliente_remito || clienteEncontrado.razon_social,
                  // cuit: clienteEncontrado.cuit
                });
              } else {
                // Si no se encuentra, crear un objeto básico
                setClienteFactura({
                  // id: props.cliente.facturar_a,
                  // razon_social: `Cliente ID: ${props.cliente.facturar_a}`,
                  // nombre_cliente_remito: `Cliente ID: ${props.cliente.facturar_a}`
                });
              }
            } else {
              // Si la respuesta no es exitosa
              console.error(
                "Error en la respuesta del servidor:",
                response.status,
              );
              setClienteFactura({
                // id: props.cliente.facturar_a,
                // razon_social: `Cliente ID: ${props.cliente.facturar_a}`,
                // nombre_cliente_remito: `Cliente ID: ${props.cliente.facturar_a}`
              });
            }
          } catch (error) {
            console.error("Error buscando cliente de facturación:", error);
            setClienteFactura({
              // id: props.cliente.facturar_a,
              // razon_social: `Cliente ID: ${props.cliente.facturar_a}`,
              // nombre_cliente_remito: `Cliente ID: ${props.cliente.facturar_a}`
            });
          }
        }
      } else {
        // Si no tiene facturar_a, limpiar
        setClienteFactura(null);
      }
    };

    buscarClienteFacturacion();
  }, [props.cliente.facturar_a]);

  return (
    <div>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.setOpen(false);
              props.actualizar();
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar cliente {dataCliente.razon_social}
            </Typography>
          </DialogTitle>
        </Box>
        <form onSubmit={guardarCliente}>
          <DialogContent>
            <Grid container spacing={1.7}>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  focused
                  style={style}
                  placeholder="Razon Social"
                  type="text"
                  required
                  name="razon_social"
                  label="Razon Social"
                  onChange={almacenar}
                  value={
                    dataCliente.razon_social &&
                    dataCliente.razon_social.replace(/\b\w/g, (l) =>
                      l.toUpperCase(),
                    )
                  }
                  inputProps={{ maxLength: 200 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 2}>
                <TextField
                  size="small"
                  style={style}
                  placeholder="Sisven ID"
                  type="text"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 6 }} //solo 2 numeros
                  focused
                  name="sisven_id"
                  label="Sisven ID"
                  color="primary"
                  onChange={almacenar}
                  value={dataCliente.sisven_id}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MeetingRoomIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={sitIvaSeleccionada?.id === 1 ? 1.5 : 3}>
                <Autocomplete
                  disabled={!tipoCliente}
                  required
                  disableClearable
                  id="id_tipocliente"
                  style={style}
                  size="small"
                  noOptionsText={"Tipo de Cliente INEXISTENTE"}
                  options={tipoCliente}
                  autoHighlight
                  getOptionLabel={(tc) => tc.descripcion}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={tipoClienteSeleccionado || null}
                  defaultValue={tipoClienteSeleccionado || null}
                  onChange={(event, value) => {
                    setTipoClienteSeleccionado(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.descripcion}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Tipo Cliente"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={sitIvaSeleccionada?.id === 1 ? 2.5 : 4}>
                <Autocomplete
                  disabled={!sitIva}
                  required
                  disableClearable
                  id="sitIva"
                  style={style}
                  size="small"
                  noOptionsText={"Situación de IVA INEXISTENTE"}
                  options={sitIva}
                  autoHighlight
                  getOptionLabel={(sit) => sit.descripcion}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sitIvaSeleccionada || null}
                  defaultValue={sitIvaSeleccionada || null}
                  onChange={(event, value) => {
                    setSitIvaSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.descripcion}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Situación IVA"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              {sitIvaSeleccionada?.id === 1 ? (
                <>
                  <Grid item xs={1.75}>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "#fff" }}
                      fullWidth
                      required
                      placeholder=""
                      disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      inputProps={{ maxLength: 9 }} //solo 2 numeros
                      name="porc_exc_perc_iva"
                      label="% Exención Perc. IVA"
                      color="primary"
                      onChange={almacenar}
                      value={dataCliente.porc_exc_perc_iva}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">%</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={1.75}>
                    <TextField
                      size="small"
                      style={{ backgroundColor: "#fff" }}
                      fullWidth
                      required={dataCliente.porc_exc_perc_iva>0? true:false}
                      placeholder=""
                      disabled={sitIvaSeleccionada?.id === 1 ? false : true}
                      type="date"
                      inputProps={{ maxLength: 9 }} //solo 2 numeros
                      name="vto_exc_perc_iva"
                      label="Vencimiento Exención"
                      color="primary"
                      onChange={almacenar}
                      value={moment(dataCliente.vto_exc_perc_iva).format(
                        "YYYY-MM-DD",
                      )}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </>
              ) : null}
              {/* <Grid item xs={4}>
                <Autocomplete
                  disabled={!categorias}
                  required
                  disableClearable
                  id="categoria"
                  // name="id_provincia"
                  style={style}
                  size="small"
                  noOptionsText={"Categoria Crediticia INEXISTENTE"}
                  options={categorias}
                  autoHighlight
                  // filterOptions={filterOptions}
                  getOptionLabel={(cat) =>
                    cat.categoria + " " + "(" + cat.descripcion + ")"
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={categoriaSeleccionada || null}
                  defaultValue={categoriaSeleccionada || null}
                  onChange={(event, value) => {
                    setCategoriaSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.categoria} ({option.descripcion})
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Categoría Crediticia"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid> */}

              
              {/* <Grid item xs={2}>
                <TextField
                  size="small"
                  style={style}
                  fullWidth
                  placeholder="100000"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 9 }} //solo 2 numeros
                  focused
                  name="limite_credito"
                  label="Límite de crédito"
                  color="primary"
                  onChange={almacenar}
                  value={dataCliente.limite_credito}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </Grid> */}
              <Grid item xs={4}>
                <TextField
                  size="small"
                  style={style}
                  focused
                  placeholder="Direccion Fiscal"
                  id="direccion_fiscal"
                  name="direccion_fiscal"
                  label="Direccion Fiscal"
                  color="primary"
                  value={
                    dataCliente.direccion_fiscal &&
                    dataCliente.direccion_fiscal.replace(/\b\w/g, (l) =>
                      l.toUpperCase(),
                    )
                  }
                  onChange={almacenar}
                  inputProps={{ maxLength: 120 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationOnIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={2.5}>
                <Autocomplete
                  disabled={!sucursales}
                  required
                  disableClearable
                  id="id_sucursal"
                  style={style}
                  size="small"
                  noOptionsText={"Sucursal INEXISTENTE"}
                  options={sucursales}
                  autoHighlight
                  getOptionLabel={(suc) => suc.nombre}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sucursalSeleccionada || null}
                  defaultValue={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setSucursalSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Sucursal"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2.5}>
                <Autocomplete
                  disabled={!provincias}
                  required
                  disableClearable
                  id="id_provincia"
                  // name="id_provincia"
                  style={style}
                  size="small"
                  noOptionsText={"Provincia INEXISTENTE"}
                  options={provincias}
                  autoHighlight
                  // filterOptions={filterOptions}
                  getOptionLabel={(pr) => pr.provincia}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={provinciaSeleccionada || null}
                  defaultValue={provinciaSeleccionada || null}
                  onChange={(event, value) => {
                    setProvinciaSeleccionada(value);
                    setBuscando(true);
                    dataCliente.id_localidad = "";
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.provincia}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Provincia"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                {buscando === true ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size="small"
                    label="Buscando Localidades..."
                  />
                ) : (
                  <Autocomplete
                    disabled={!localidades}
                    required
                    disableClearable
                    id="id_localidad"
                    style={style}
                    size="small"
                    noOptionsText={"Localidad INEXISTENTE"}
                    options={localidades}
                    autoHighlight
                    getOptionLabel={(loc) => loc.localidad}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={localidadSeleccionada || null}
                    defaultValue={localidadSeleccionada || null}
                    onChange={(event, value) => {
                      setLocalidadSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.localidad}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Localidad"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
<Grid item xs={1}>
                <FormControl required style={style} focused size="small">
                  <InputLabel>Cuit/Dni</InputLabel>
                  <Select
                    name="tipo_doc_afip"
                    labelId="Cuit/Dni"
                    disabled={sitIvaSeleccionada?.id !== 4}
                    value={dataCliente.tipo_doc_afip}
                    label="tipo_doc_afip"
                    onChange={almacenar}
                  >
                    <MenuItem value={80}>Cuit</MenuItem>
                    <MenuItem value={96}>Dni</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {dataCliente.tipo_doc_afip === 80 ? (
                <Grid item xs={3}>
                  <InputMask
                    mask="99999999999"
                    value={dataCliente.cuit}
                    disabled={false}
                    maskChar=" "
                    onChange={almacenar}
                  >
                    {() => (
                      <TextField
                        size="small"
                        style={style}
                        type="text"
                        focused
                        name="cuit"
                        label="Numero Cuit"
                      />
                    )}
                  </InputMask>
                </Grid>
              ) : (
                <Grid item xs={3}>
                  <InputMask
                    mask="99999999"
                    value={dataCliente.cuit}
                    disabled={false}
                    maskChar=" "
                    onChange={almacenar}
                  >
                    {() => (
                      <TextField
                        size="small"
                        style={style}
                        type="text"
                        focused
                        name="cuit"
                        label="Numero Dni"
                      />
                    )}
                  </InputMask>
                </Grid>
              )}
              <Grid item xs={2.5}>
                <Autocomplete
                  disabled={!condiciones}
                  required
                  disableClearable
                  id="id_condicionpago"
                  // name="id_provincia"
                  style={style}
                  size="small"
                  noOptionsText={"Condición de Pago INEXISTENTE"}
                  options={condiciones}
                  autoHighlight
                  // filterOptions={filterOptions}
                  getOptionLabel={(cond) => cond.condicion}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={condPagoSeleccionada || null}
                  defaultValue={condPagoSeleccionada || null}
                  onChange={(event, value) => {
                    setCondPagoSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.condicion}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Condición de Pago"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2.5}>
                <Autocomplete
                  disabled={!comerciales}
                  required
                  disableClearable
                  id="id_comercial"
                  style={style}
                  size="small"
                  noOptionsText={"Comercial INEXISTENTE"}
                  options={comerciales}
                  autoHighlight
                  getOptionLabel={(c) => c.nombre_apellido}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={comercialSeleccionado || null}
                  defaultValue={comercialSeleccionado || null}
                  onChange={(event, value) => {
                    setComercialSeleccionado(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.nombre_apellido}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Comercial"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="number"
                    color="primary"
                    placeholder="..."
                    name="envase_10_kg"
                    label="Envase 10 KG"
                    focused
                    onChange={almacenar}
                    value={dataCliente.envase_10_kg}
                    inputProps={{
                      maxLength: 10,
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="number"
                    color="primary"
                    placeholder="..."
                    name="envase_15_kg"
                    label="Envase 15 KG"
                    focused
                    onChange={almacenar}
                    value={dataCliente.envase_15_kg}
                    inputProps={{
                      maxLength: 10,
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    type="number"
                    color="primary"
                    placeholder="..."
                    name="envase_45_kg"
                    label="Envase 45 KG"
                    focused
                    onChange={almacenar}
                    value={dataCliente.envase_45_kg}
                    inputProps={{
                      maxLength: 10,
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </FormControl>
              </Grid> */}
              <Grid item xs={3}>
                <Autocomplete
                  disabled={!usos}
                  required
                  disableClearable
                  id="uso"
                  style={style}
                  size="small"
                  noOptionsText={"Uso INEXISTENTE"}
                  options={usos}
                  autoHighlight
                  getOptionLabel={(u) => u.uso}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={usoSeleccionado || null}
                  defaultValue={usoSeleccionado || null}
                  onChange={(event, value) => {
                    setUsoSeleccionado(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.uso}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Uso"
                      focused
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              {sitIvaSeleccionada?.inscripcion_iibb===1?
              <>
               <Grid item xs={3}>
                <Autocomplete
                  disabled={!convenios}
                  required
                  disableClearable
                  id="convenios"
                  style={style}
                  size={"small"}
                  noOptionsText={"Convenio INEXISTENTE"}
                  options={convenios}
                  autoHighlight
                  getOptionLabel={(c) =>
                    c.id_convenio + "-" + c.convenio
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id_convenio === value?.id_convenio
                  }
                  value={convenioSeleccionado || null}
                  defaultValue={convenioSeleccionado || null}
                  onChange={(event, value) => {
                    setConvenioSeleccionado(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id_convenio}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_convenio} - {option.convenio}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      required
                      {...params}
                      label="Convenio"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size={"small"}
                  style={style}
                  placeholder="N° Inscripción IIBB"
                  id="iibb_nro_inscripcion"
                  name="iibb_nro_inscripcion"
                  label="N° Inscripción IIBB"
                  color="primary"
                  value={dataCliente.iibb_nro_inscripcion || ''}
                  onChange={(e) => almacenar(e)}
                  inputProps={{ 
                    maxLength: convenioSeleccionado?.id_convenio === 1 ? 13 : 200 
                  }}
                />
              </Grid>
              </>
              :null}
              <Grid item xs={sitIvaSeleccionada?.inscripcion_iibb===1?6:12}>
                <TextField
                  size="small"
                  style={style}
                  placeholder="Observaciones"
                  id="observaciones"
                  name="observaciones"
                  label="Observaciones"
                  color="primary"
                  focused
                  value={dataCliente.observaciones}
                  onChange={almacenar}
                  inputProps={{ maxLength: 200 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  style={style}
                  size="small"
                  focused
                  placeholder="Mails"
                  id="mails"
                  name="mails"
                  label="Mails"
                  color="primary"
                  value={dataCliente.mails}
                  onChange={almacenar}
                  inputProps={{ maxLength: 500 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ContactMailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  style={style}
                  size="small"
                  type="text"
                  focused
                  color="primary"
                  placeholder="Telefono 1"
                  name="telefono_1"
                  id="telefono_1"
                  label="Telefono 1"
                  onChange={almacenar}
                  value={dataCliente.telefono_1}
                  inputProps={{
                    maxLength: 10,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{codArg}</InputAdornment>
                    ),
                  }}
                  // helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  style={style}
                  size="small"
                  type="text"
                  focused
                  color="primary"
                  placeholder="Telefono 2"
                  name="telefono_2"
                  label="Telefono 2"
                  onChange={almacenar}
                  value={dataCliente.telefono_2}
                  inputProps={{
                    maxLength: 10,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{codArg}</InputAdornment>
                    ),
                  }}
                  // helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  style={style}
                  size="small"
                  type="text"
                  focused
                  color="primary"
                  placeholder="Telefono 3"
                  name="telefono_3"
                  label="Telefono 3"
                  onChange={almacenar}
                  value={dataCliente.telefono_3}
                  inputProps={{
                    maxLength: 10,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{codArg}</InputAdornment>
                    ),
                  }}
                  // helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Grid>

              {/* <Grid item xs={2.4} alignContent={"unset"}>
                <FormGroup>
                  <FormControlLabel
                    label="Precio Especial"
                    control={
                      <Checkbox
                        checked={checkedPrecioEspecial}
                        onChange={handleCheckedPrecioEspecial}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                  />
                </FormGroup>
              </Grid> */}
              <Grid item xs={2.5}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: checkedPrecioEspecial
                      ? "primary.main"
                      : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: checkedPrecioEspecial
                      ? "primary.50"
                      : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: checkedPrecioEspecial
                        ? "primary.100"
                        : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  onClick={() => setCheckedPrecioEspecial((prev) => !prev)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={checkedPrecioEspecial}
                      // onChange={handleChangeChecked}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Precio Especial
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {/* <Grid item xs={2.4} alignContent={"unset"}>
                <FormGroup>
                  <FormControlLabel
                    label="Factura Consumidor Final"
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleChangeChecked}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                  />
                </FormGroup>
              </Grid> */}
              <Grid item xs={3}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: checked ? "primary.main" : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: checked ? "primary.50" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: checked ? "primary.100" : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  onClick={() => setChecked((prev) => !prev)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={checked}
                      // onChange={handleChangeChecked}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Factura Consumidor Final
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={2.5}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 0.5,
                    border: "2px solid",
                    borderColor: checkedEntregaConRemito
                      ? "primary.main"
                      : "grey.300",
                    borderRadius: 3,
                    height: 38,
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    bgcolor: checkedEntregaConRemito
                      ? "primary.50"
                      : "transparent",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                      borderColor: "primary.main",
                      bgcolor: checkedEntregaConRemito
                        ? "primary.100"
                        : "grey.50",
                      transform: "translateY(-2px)",
                      boxShadow: 2,
                    },
                  }}
                  // onClick={handleCheckedEntregaConRemito}
                  onClick={() => setCheckedEntregaConRemito((prev) => !prev)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    width="100%"
                    // onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={checkedEntregaConRemito}
                      // onChange={handleCheckedEntregaConRemito}
                      tabIndex={-1}
                      disableRipple
                      sx={{
                        "& .MuiSvgIcon-root": { fontSize: 28 },
                      }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ userSelect: "none" }}
                    >
                      Entrega con Remito
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {(checkedEntregaConRemito || clienteFactura) && (
                <Grid item xs={12} md={4}>
                  <BuscadorClienteFactura
                    value={clienteFactura}
                    onChange={handleClienteFacturaChange}
                    style={style}
                    size={"small"}
                    label="Facturar a"
                    placeholder="Buscar cliente por razón social, CUIT..."
                  />
                </Grid>
              )}
            </Grid>
            {cambioSucursalConHojas && (
              <Alert severity="warning" sx={{ mt: 1 }}>
                El cliente está asignado a las siguientes hojas de ruta. Si
                cambia la sucursal, revise las hojas:
                <ul style={{ margin: 0 }}>
                  {hojas.map((h) => (
                    <li key={h.id}>{h.nombre_hoja}</li>
                  ))}
                </ul>
              </Alert>
            )}
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid item>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Button
                  type="submit"
                  color="success"
                  variant="contained"
                  disabled={disBtn}
                  endIcon={<SaveIcon />}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
            {/* </Box> */}
          </DialogContent>
        </form>
      </Dialog>
    </div>
  );
}

export default EdicionEnvasado;
